export enum ControlEvent {
	CLICK = 'click',
	CHANGE = 'change',
}
